var map = {
	"./android.svg": "1679",
	"./atv.svg": "8e21",
	"./chrome.svg": "acda",
	"./chromecast.svg": "4950",
	"./cloudsync.svg": "dd27",
	"./default.svg": "75d5",
	"./dlna.svg": "f567",
	"./firefox.svg": "b1db",
	"./gtv.svg": "0d27",
	"./ie.svg": "3e24",
	"./ios.svg": "019d",
	"./kodi.svg": "d103",
	"./linux.svg": "f0bd",
	"./macos.svg": "dd58",
	"./msedge.svg": "f441",
	"./opera.svg": "c307",
	"./playstation.svg": "77c0",
	"./plex.svg": "258d",
	"./plexamp.svg": "0f14",
	"./roku.svg": "6d9a",
	"./safari.svg": "ea56",
	"./samsung.svg": "f84b",
	"./synclounge.svg": "9f98",
	"./tivo.svg": "0cd8",
	"./wiiu.svg": "7eab",
	"./windows.svg": "dfe9",
	"./xbox.svg": "abfa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5992";